import { API_URL } from 'utils/constants/app';
import { RequestHelper } from 'utils/helpers/RequestHelper';

const CountryServiceUrl = `${API_URL}/countries`;

const getCountries = () => RequestHelper.GET(`${CountryServiceUrl}`);

export const CountryService = {
  getCountries
};